<!--
 * @FileDescription: 分销等级
 * @Author: xy（作者）
 * @Date: 2020-12-31（时间）
 * @LastEditors: xy（最后更新人）
 * @LastEditTime: 2020-04-13（最后更新时间）
 -->
<template>
  <div class="page-container">
      <div class="page-container-height">
          <div class="grade-top">
               <a-input  class="market-input" v-model="keyword" placeholder="请输入用户手机号"  @pressEnter="onSearch()" />
                <a-button class="button-search" @click.stop="onSearch()">筛选</a-button>
                <a-button class="button-search1" @click.stop="onRest(1)">重置</a-button>
          </div>
           <div class="line"></div>
            <div class="market-tab">
                <div class="market-tab-item" :class="tabindex == 4 ? 'market-tab-item-active':''" @click="changTab(4)">
                    <img src="@/assets/image/adjustment-img4.png" alt="" v-if="tabindex == 4">
                    <img src="@/assets/image/adjustment-img1.png" alt="" v-else>
                    全部
                </div>
                 <div class="market-tab-line"></div>
                <div class="market-tab-item" :class="tabindex == 0 ? 'market-tab-item-active':''" @click="changTab(0)">
                    <img src="@/assets/image/youxuanyonghu.png" alt="" v-if="tabindex == 0">
                    <img src="@/assets/image/youxuanyonghu1.png" alt="" v-else>
                    优选用户
                </div>
                <div class="market-tab-line"></div>
                <div class="market-tab-item" :class="tabindex == 1 ? 'market-tab-item-active':''" @click="changTab(1)">
                    <img src="@/assets/image/V1@3x.png" alt="" v-if="tabindex == 1">
                    <img src="@/assets/image/V1-1@3x.png" alt="" v-else>
                    团长
                </div>
                 <div class="market-tab-line"></div>
                <div class="market-tab-item" :class="tabindex == 2? 'market-tab-item-active':''" @click="changTab(2)">
                    <img src="@/assets/image/V2@3x.png" alt="" v-if="tabindex == 2">
                    <img src="@/assets/image/V2-1@3x.png" alt="" v-else>
                    合伙人
                </div>
                 <div class="market-tab-line"></div>
                <div class="market-tab-item" :class="tabindex == 3? 'market-tab-item-active':''" @click="changTab(3)">
                    <img src="@/assets/image/V3@3x.png" alt="" v-if="tabindex == 3">
                    <img src="@/assets/image/V3-1@3x.png" alt="" v-else>
                    联合创始人
                </div>
            </div>
             <a-table :columns="columns"
                     :dataSource="dataSource"
                     :pagination="false"
                     :scroll="{y: 'calc(100vh - 310px)' }"
                     class="table-log-height"
                     bordered
                     rowKey="key">
                <template slot="operation" slot-scope="text, record, index">
                    <a-tooltip>
                        <template slot="title">
                            {{record.changeReason}}
                        </template>
                       <span style="color:#387bfc">{{record.changeReason}}</span>
                    </a-tooltip>
                </template>
                <template slot="time" slot-scope="text, record, index">
                   <span>{{record.startTime}} --- {{record.endTime}}</span>
                </template>
            </a-table>
             <div class="pagination-footer-box">
                <a-pagination :total="pagination.total" :page-size="pagination.pageSize" :default-current="pagination.current"
                    :show-total="pagination.showTotal" @showSizeChange="onShowSizeChange" @change="handleTableChange"
                    show-size-changer show-quick-jumper />
            </div>
      </div>
  </div>
</template>
<script>
import {getPageAccount} from "@/utils/api";
import {mixins} from "@/mixins/mixins";
import {method} from '../method/method'
export default {
    mixins:[mixins,method],
    data(){
        return{
            keyword:'',
            tabindex:4,
            columns: [
                {
                    title: '',
                    dataIndex: '',
                    key: 'rowIndex',
                    width: 70,
                    align: 'center',
                    fixed: 'left',
                    customRender(t, r, index) {
                        return parseInt(index) + 1
                    }
                },
                {
                    title: '绑定手机号',
                    key: 'mobile',
                    dataIndex: 'mobile',
                },
                {
                    title: '当前等级',
                    key: 'gradeName',
                    dataIndex: 'gradeName',
                },
                {
                    title: '等级变动时间',
                    key: 'gradeChangeTime',
                    dataIndex: 'gradeChangeTime',
                },
                {
                    title: '升（降）级原因',
                    key: 'changeReason',
                    dataIndex:'changeReason',
                    scopedSlots: { customRender: 'operation' },
                },
                {
                    title: '起止时间',
                    key: 'startTime',
                    dataIndex:'startTime',
                    scopedSlots: { customRender: 'time' },
                },
            ],
            dataSource: [],
        }
    },
    watch: {

    },
    mounted () {
        this.getmessagedata()
    },
    created () {

    },
    components: {


    },
    methods: {
        /**
        * @description: 此为方法注释（方法描述）
        */
        getmessagedata(){
            this.getmessageobj('/mall-account/web/grade/pageListGrade',{   
                    companyStoreId:this.$store.state.shopId,
                    current:this.pagination.current,
                    size:this.pagination.pageSize,
                    gradeType:this.tabindex,
                    mobile:this.keyword
                },{})
        },
        /**
        * @description: 筛选
        */
        onSearch(){
            this.getmessagedata()
        },
         /**
        * @description: 重置
        */
        onRest(){
            this.keyword = ''
            this.pagination.current = 1
            this.getmessagedata()
        },
        changTab(index){
            this.tabindex = index
            this.pagination.current = 1
            this.getmessagedata()
        },
    },

}
</script>
<style scoped lang="scss">
.page-container-height{
    background: #ffffff;
    .grade-top{
        height: 80px;
        display: flex;
        align-items: center;
        padding-left: 30px;
        .grade-time{
            width: 260px;
            margin-right: 20px;
        }
        .market-input{
            width: 260px;
            margin-right: 10px;
        }
    }
    .market-tab{
        padding: 10px 30px;
        display: flex;
        align-items: center;
        .market-tab-item{
            color: #919191;
            font-size: 16px;
            img{
                width: 32px;
                height: 32px;
                margin-right: 10px;
            }
        }
        .market-tab-item-active{
            color: #387bfc;
        }
        .market-tab-line{
            width: 1px;
            height: 18px;
            background: #919191;
            margin: 0 30px;
        } 
    }
}
.set-goods{
    color: #387bfc;
    cursor: pointer;
}
</style>
